export const UNSUBSCRIBED_CONTACT_CREATE_OPEN_MODAL = "UNSUBSCRIBED_CONTACT_CREATE_OPEN_MODAL";
export const UNSUBSCRIBED_CONTACT_CREATE_CLOSE_MODAL = "UNSUBSCRIBED_CONTACT_CREATE_CLOSE_MODAL";

export const UNSUBSCRIBED_CONTACT_CREATE_REQUEST = "UNSUBSCRIBED_CONTACT_CREATE_REQUEST";
export const UNSUBSCRIBED_CONTACT_CREATE_RESULT = "UNSUBSCRIBED_CONTACT_CREATE_RESULT";
